export const HealthProErrorCode = {
    HEALTH_PRO_SLUG_ALREADY_EXISTS: 'HEALTH_PRO_SLUG_ALREADY_EXISTS'
} as const;